//# sourceMappingURL=jobs.mjs.map
/// <reference types="./jobs.d.mts" />
import * as $button from "../../../ds/ds/components/button.mjs";
import * as $callout from "../../../ds/ds/components/callout.mjs";
import * as $l from "../../../ds/ds/components/layout.mjs";
import * as $modal from "../../../ds/ds/components/modal.mjs";
import * as $typography from "../../../ds/ds/components/typography.mjs";
import * as $utils from "../../../ds/ds/utils.mjs";
import * as $promise from "../../../gleam_javascript/gleam/javascript/promise.mjs";
import * as $result from "../../../gleam_stdlib/gleam/result.mjs";
import * as $redraw from "../../../redraw/redraw.mjs";
import * as $a from "../../../redraw_dom/redraw/dom/attribute.mjs";
import * as $e from "../../../redraw_dom/redraw/dom/events.mjs";
import * as $html from "../../../redraw_dom/redraw/dom/html.mjs";
import * as $h from "../../../sketch_redraw/sketch/redraw/dom/html.mjs";
import * as $function from "../../../tiamat/tiamat/function.mjs";
import * as $automations_effects from "../../admin/effects/automations.mjs";
import * as $store from "../../data/store.mjs";
import { Ok, Error, toList } from "../../gleam.mjs";

function use_trigger_worksheets_backfill_click(confirm) {
  let modal = $modal.use_modal();
  let dispatch = $store.use_effect_dispatch();
  return ((_capture) => { return $redraw.use_callback(_capture, [confirm]); })(
    (_) => {
      return $function.tap(
        undefined,
        (_) => {
          let return$ = modal.open(confirm);
          return $promise.map(
            return$,
            (return$) => {
              return $result.map(
                return$,
                (_) => {
                  return dispatch(
                    $automations_effects.trigger_worksheets_backfill(),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function confirm_trigger_worksheets_backfill() {
  return $redraw.component_(
    "ConfirmTriggerWorksheetsBackfill",
    (props) => {
      let on_cancel = $e.on_click(
        (_) => { return props.on_end(new Error(undefined)); },
      );
      let on_confirm = $e.on_click(
        (_) => { return props.on_end(new Ok(undefined)); },
      );
      return $modal.modal(
        toList([]),
        toList([
          $modal.body(
            toList([$utils.stop_propagation()]),
            toList([
              $modal.title(
                toList([]),
                toList([$h.text("Are you sure you want to run the backfill?")]),
              ),
              $modal.explanations(
                toList([]),
                toList([
                  $h.text(
                    "This scans the proposal and project_file tables for inline ",
                  ),
                  $h.text(
                    "worksheets and writes them to S3. The scan reads every ",
                  ),
                  $h.text("metadata column, so avoid running it at peak hours."),
                ]),
              ),
              $modal.actions(
                toList([]),
                toList([
                  $button.primary(
                    toList([on_cancel]),
                    toList([$h.text("Cancel")]),
                  ),
                  $button.secondary(
                    toList([on_confirm]),
                    toList([$h.text("Submit")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function trigger_worksheets_backfill() {
  return $redraw.compose(
    confirm_trigger_worksheets_backfill(),
    (confirm) => {
      return $redraw.component_(
        "TriggerWorksheetsBackfill",
        (_) => {
          let on_click = use_trigger_worksheets_backfill_click(confirm);
          return $callout.info(
            toList([]),
            toList([
              $callout.header(
                toList([]),
                toList([$h.text("Backfill worksheets")]),
              ),
              $callout.content(
                toList([]),
                toList([
                  $h.text(
                    "Manually runs one batch of the worksheets-to-S3 backfill ",
                  ),
                  $h.text(
                    "(20 proposals, then 20 project files). Both backlogs are ",
                  ),
                  $h.text(
                    "drained, so this is a no-op unless inline worksheets reappear.",
                  ),
                  $html.div(
                    toList([$a.style(toList([["height", "12px"]]))]),
                    toList([]),
                  ),
                  $button.primary(
                    toList([$e.on_click(on_click)]),
                    toList([$h.text("Run backfill")]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

function use_trigger_auth0_organizations_sync_click(confirm) {
  let modal = $modal.use_modal();
  let dispatch = $store.use_effect_dispatch();
  return ((_capture) => { return $redraw.use_callback(_capture, [confirm]); })(
    (_) => {
      return $function.tap(
        undefined,
        (_) => {
          let return$ = modal.open(confirm);
          return $promise.map(
            return$,
            (return$) => {
              return $result.map(
                return$,
                (_) => {
                  return dispatch(
                    $automations_effects.trigger_auth0_organizations_sync(),
                  );
                },
              );
            },
          );
        },
      );
    },
  );
}

function confirm_trigger_auth0_organizations_sync() {
  return $redraw.component_(
    "ConfirmTriggerAuth0OrganizationsSync",
    (props) => {
      let on_cancel = $e.on_click(
        (_) => { return props.on_end(new Error(undefined)); },
      );
      let on_confirm = $e.on_click(
        (_) => { return props.on_end(new Ok(undefined)); },
      );
      return $modal.modal(
        toList([]),
        toList([
          $modal.body(
            toList([$utils.stop_propagation()]),
            toList([
              $modal.title(
                toList([]),
                toList([
                  $h.text(
                    "Are you sure you want to trigger the Auth0 organizations ",
                  ),
                  $h.text("sync?"),
                ]),
              ),
              $modal.explanations(
                toList([]),
                toList([
                  $h.text(
                    "This runs the same job as the 12h cron: it fetches every ",
                  ),
                  $h.text("organization from Auth0 and upserts it into the "),
                  $h.text("auth0_organizations table."),
                ]),
              ),
              $modal.actions(
                toList([]),
                toList([
                  $button.primary(
                    toList([on_cancel]),
                    toList([$h.text("Cancel")]),
                  ),
                  $button.secondary(
                    toList([on_confirm]),
                    toList([$h.text("Submit")]),
                  ),
                ]),
              ),
            ]),
          ),
        ]),
      );
    },
  );
}

function trigger_auth0_organizations_sync() {
  return $redraw.compose(
    confirm_trigger_auth0_organizations_sync(),
    (confirm) => {
      return $redraw.component_(
        "TriggerAuth0OrganizationsSync",
        (_) => {
          let on_click = use_trigger_auth0_organizations_sync_click(confirm);
          return $callout.info(
            toList([]),
            toList([
              $callout.header(toList([]), toList([$h.text("Sync now")])),
              $callout.content(
                toList([]),
                toList([
                  $h.text(
                    "Manually runs the Auth0 organizations sync job, as the 12h ",
                  ),
                  $h.text(
                    "cron does. This is a global action, not scoped to a single ",
                  ),
                  $h.text("organization."),
                  $html.div(
                    toList([$a.style(toList([["height", "12px"]]))]),
                    toList([]),
                  ),
                  $button.primary(
                    toList([$e.on_click(on_click)]),
                    toList([$h.text("Sync now")]),
                  ),
                ]),
              ),
            ]),
          );
        },
      );
    },
  );
}

export function view() {
  return $redraw.compose(
    trigger_auth0_organizations_sync(),
    (trigger_auth0_organizations_sync) => {
      return $redraw.compose(
        trigger_worksheets_backfill(),
        (trigger_worksheets_backfill) => {
          return $redraw.component_(
            "Jobs",
            (_) => {
              return $l.column(
                toList([$l.gap(24), $l.align("start")]),
                toList([]),
                toList([
                  $typography.h1($typography.md, "Jobs"),
                  $l.column(
                    toList([$l.gap(48), $l.align("start")]),
                    toList([]),
                    toList([
                      $l.column(
                        toList([$l.gap(12)]),
                        toList([]),
                        toList([
                          $typography.h2(
                            $typography.xs,
                            "Auth0 organizations sync",
                          ),
                          trigger_auth0_organizations_sync(undefined),
                        ]),
                      ),
                      $l.column(
                        toList([$l.gap(12)]),
                        toList([]),
                        toList([
                          $typography.h2($typography.xs, "Worksheets backfill"),
                          trigger_worksheets_backfill(undefined),
                        ]),
                      ),
                    ]),
                  ),
                ]),
              );
            },
          );
        },
      );
    },
  );
}
